import { render, staticRenderFns } from "./SettingsPaymentMethodsDetails.vue?vue&type=template&id=6c57810c&scoped=true"
import script from "./SettingsPaymentMethodsDetails.vue?vue&type=script&lang=js"
export * from "./SettingsPaymentMethodsDetails.vue?vue&type=script&lang=js"
import style0 from "./SettingsPaymentMethodsDetails.vue?vue&type=style&index=0&id=6c57810c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c57810c",
  null
  
)

export default component.exports